import { Create } from 'react-admin';
import { OrderDetailForm } from './OrderDetail.Form';

export const OrderDetailCreate = () => {
    return (
        <Create redirect="list">
            <OrderDetailForm />
        </Create>
    );
};
